import Props from "./props";
import styled from "styled-components";

const StyledFormGroup = styled.div<Props>`
    padding-bottom: 0.8rem;
    text-align: ${({ alignRight }) => (alignRight ? "right" : "left")};
    &:last-child {
        padding-bottom: 0;
    }
`;

export default StyledFormGroup;
